import FixedHeader from 'vue-fixed-header';
import { Vue } from 'nuxt-property-decorator';

Vue.component('fixed-header', FixedHeader);
